exports.f = require('../internals/well-known-symbol');



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/internals/wrapped-well-known-symbol.js
// module id = 4AHv
// module chunks = 0